export default __webpack_public_path__ + "static/media/017-angkor wat.b3690a48.svg";